import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {setBodyScroll} from "assets/js/commonUtil"

import Img02 from 'assets/images/img02.png';

interface ParentProps  {
  imgUrl : string;
  imgText : string;
  textcolor: string;
}

const TopImage = ({imgUrl, imgText, textcolor}: ParentProps) => {  
  const { pathname } = useLocation();
  
  setBodyScroll();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="top-img-wrapper">
      <img src={imgUrl} alt="Top Image" />
      <div className="top-img-text" style={{color:textcolor}}>
        {imgText}
      </div>
    </div>
  );
}
export default TopImage;
